import { rgba } from 'polished';
import styled from 'styled-components';

export const StyledModalWrapper = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) =>
    `${rgba(theme.colors.cross.deepBlu, 0.5)}`};
  justify-content: center;
  align-items: center;
  z-index: 200;
`;
